var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7421 16.0806L10.9365 8.32341C11.7359 6.32432 11.3233 3.9664 9.69857 2.3432C7.72137 0.378279 4.88335 -0.0730007 3.21988 1.26704L6.52094 4.55615L3.93718 6.97919L0.644719 3.70716C-0.466176 5.31557 -0.178828 8.24653 1.79837 10.2029C3.39732 11.7919 5.72698 12.2106 7.72137 11.4673L15.5528 19.2501C15.8881 19.5833 16.4296 19.5833 16.7649 19.2501L18.7421 17.2852C19.086 16.9605 19.086 16.4223 18.7421 16.0806Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1631 17.4475L8.03084 9.36563C7.50645 9.75007 6.92189 9.98074 6.31153 10.0662C5.14241 10.237 3.9131 9.88676 3.01907 8.99827C2.2024 8.19522 1.82415 7.11878 1.88433 6.05943L4.54065 8.69926L8.18557 5.07696L5.52925 2.43713C6.59522 2.37733 7.66978 2.75323 8.48645 3.55628C9.41488 4.47894 9.76733 5.75187 9.55242 6.93937C9.44926 7.54594 9.19137 8.10978 8.79593 8.61383L16.9196 16.6871L16.1631 17.4475Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.379cd09e29697d671db9d2676f0842c8.svg";
export { ForwardRef as ReactComponent };